module.exports = __webpack_public_path__ + "static/media/eva_logo_bottom_text.7b8b009f.png";